/* @flow */

import getCorFundo from '../usuario/get-cor-fundo';

export default (nome: string) => `
<div class="m-card-user m-card-user--sm">
    <div class="m-card-user__pic">
        <div class="m-card-user__no-photo m--bg-fill-${getCorFundo(nome.charAt(0))}">
            <span>${nome.charAt(0)}</span>
        </div>
    </div>
</div>`;
